import React, { useState, useEffect } from "react";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import Layout from "../../../layouts/Layout";
import AddMessage from "./AddMessage";
import {
  getSystemMessages,
  deleteSystemMessage,
} from "../../../_redux/actions/ActionSettings";

import { connect } from "react-redux";
import PaginationComp from "../../../components/PaginationComp";
import Loader from "../../../components/Loader";
import swal from "sweetalert";

const SystemMessage = ({
  getSystemMessages,
  messages,
  deleteSystemMessage,
  totalMessages,
  loading,
}) => {
  const [showAdd, setShowAdd] = useState(false);
  const [page, setPage] = useState(1);
  const [systemMessage, setSystemMessage] = useState(null);
  useEffect(() => {
    getSystemMessages(page);
  }, [getSystemMessages, page]);
  return (
    <Layout>
      <div className="questions-section">
        <Row className="mt-3">
          <Col md={4}>
            <h5 className="font-weight-bold text-danger mb-2">
              System Message
            </h5>
          </Col>
          <Col md={{ span: 2, offset: 6 }}>
            {!showAdd && (
              <Button
                className="btn-primary btn-round float-right mb-2"
                onClick={() => {
                  setShowAdd(!showAdd);
                  setSystemMessage(null);
                }}
              >
                Add Message
              </Button>
            )}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md={12}>
            {showAdd && (
              <AddMessage
                showAdd={showAdd}
                setShowAdd={setShowAdd}
                systemMessage={systemMessage}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="dashboard-table">
              <Card className="table-minheight">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S.N.</th>
                      <th>Type</th>
                      <th>Message</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!loading ? (
                      messages.length > 0 &&
                      messages.map((item, index) => {
                        return (
                          <tr>
                            <td width="5%">{(page - 1) * 10 + (index + 1)}</td>
                            <td width="15%" className="textCapitalize">
                              {item.system_messages_type}
                            </td>

                            <td width="55%">{item.message}</td>
                            <td width="10%" className="text-center">
                              <FaEdit
                                className="text-info pointer mr-1"
                                onClick={() => {
                                  setShowAdd(!showAdd);
                                  setSystemMessage(item);
                                }}
                              />
                              <FaTrashAlt
                                className="text-danger pointer"
                                onClick={() => {
                                  swal({
                                    title: "Are you sure?",
                                    text: "Once deleted, you will not be able to recover !",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                  }).then((willDelete) => {
                                    if (willDelete) {
                                      deleteSystemMessage(item.id);
                                    }
                                  });
                                }}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <Loader />
                    )}
                  </tbody>
                </Table>
                {totalMessages > 10 && (
                  <PaginationComp
                    total={totalMessages}
                    page={page}
                    setPage={setPage}
                  />
                )}
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  messages: state.messages.messages,
  totalMessages: state.messages.totalMessages,
  loading: state.ui.loading,
});

export default connect(mapStateToProps, {
  getSystemMessages,
  deleteSystemMessage,
})(SystemMessage);
